import React, {useEffect, useState} from 'react';
import CustomSwitch from "../customSwitch/CustomSwitch";

// css
import '../../../src/assets/css/Categorizer.css'
import {Alert} from "reactstrap";

const Grouper = ({
    items,
    grouper,
    children,
     noItemsFoundMessage = "No hay elementos para mostrar"
}) => {
    const [groperItems, setGroperItems] = useState([])
    const [clickedItem, setClickedItem] = useState(0)
    const [filteredData, setFilteredData] = useState([])

    useEffect(() => {
        if (items.length === 0)
            return

        setGroupedItems()
    }, [items]);

    useEffect(() => {
        if (groperItems.length === 0)
            return

        filterData(0)
    }, [groperItems]);

    const setGroupedItems = () => {
        const groupers = Object.values(items).map(item => item[grouper]);
        const uniqueArray = [...new Set(groupers)];

        setGroperItems(uniqueArray)
    }

    const filterData = (clickedItem) => {
        const data = items.filter(item => item[grouper] === groperItems[clickedItem])
        setFilteredData(data)
    }

    const onClick = (clickedKey) => {
        setClickedItem(clickedKey)
        filterData(clickedKey)
    }

    if (groperItems?.length === 0)
        return <Alert  color="danger">
                            <span className="fa-stack">
                              <i className="fa fa-exclamation-triangle"/>
                            </span>
            {noItemsFoundMessage}
        </Alert>



    return <div className={'categorized-section'}>
        <div className={'categories'}>
            {
                groperItems.map((item, index) => (
                    <CustomSwitch
                        key={index}
                        label={item}
                        checked={index === clickedItem}
                        onClick={() => onClick(index)}
                    />
                ))
            }
        </div>
        <div className={'categorized-items'}>
            {
                filteredData.map((item, index) => (children(item)))
            }
        </div>
    </div>
}

export default Grouper;